import { render, staticRenderFns } from "./RegbiteAdd.vue?vue&type=template&id=0ed3f75e&"
import script from "./RegbiteAdd.vue?vue&type=script&lang=js&"
export * from "./RegbiteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports